<div class="panel panel-primary" [ngClass]="{ 'panel-closed': isCollapsed, 'panel-opened': !isCollapsed, 'panel-enabled': !isDisabled, 'panel-disabled': isDisabled }">
	<div class="panel-heading" (click)="expandCollapse($event)" *ngIf="!hideHeading">
		<div class="hmf-display-flex hmf-align-items-center" [ngClass]="{ 'hmf-justify-content-center': isTitleCentered }">
			<ng-content select="[myPanelHeader]" [ngClass]="{ 'hmf-flex-grow': !isArrowIconCentered }"></ng-content>
			<button *ngIf="!isDisabled" class="button-accordion-toggle header-icon hmf-display-flex hmf-justify-content-center hmf-align-items-center hmf-ml-xxs" [hidden]="hideArrowIcon" [ngClass]="{'small-icon': arrowIconSmall, 'arrow-up': !isCollapsed }" aria-label="{{altText}}">
				<homefield-icon class="chevron-up" width="24px" height="24px" name="chevron-down" alt="{{altText}}"></homefield-icon>
			</button>
		</div>
		@if (!hideHeaderLine) {
			<hr [ngClass]="{'hmf-display-none hmf-display-m-block': hideMobileHeaderLine}">
		}
	</div>
	<div class="panel-heading-secondary">
		<ng-content select="[myPanelHeaderSecondary]"></ng-content>
	</div>
	<div class="panel-collapse-container">
		<div class="panel-body" [@openClose]="isCollapsed ? 'closed' : 'open'">
			<ng-content select="[myPanelBody]" *ngIf="!hideBodyAndFooter"></ng-content>
		</div>
		<div class="panel-footer" [@openClose]="isCollapsed ? 'closed' : 'open'">
			<ng-content select="[myPanelFooter]" *ngIf="!hideBodyAndFooter"></ng-content>
		</div>
	</div>
</div>
